import { render } from "./switcher.vue?vue&type=template&id=9dc5eda6&scoped=true"
import script from "./switcher.vue?vue&type=script&lang=js"
export * from "./switcher.vue?vue&type=script&lang=js"

import "./switcher.vue?vue&type=style&index=0&id=9dc5eda6&lang=scss&scoped=true"

import exportComponent from "/build/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-9dc5eda6"],['__file',"src/components/Checkbox/switcher.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "9dc5eda6"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('9dc5eda6', __exports__)) {
    console.log('reload')
    api.reload('9dc5eda6', __exports__)
  }
  
  module.hot.accept("./switcher.vue?vue&type=template&id=9dc5eda6&scoped=true", () => {
    console.log('re-render')
    api.rerender('9dc5eda6', render)
  })

}


export default __exports__